import React from 'react';

export default function ChatIcon({ active = false, size = 34, ...props }) {
  const strokeColor = active ? '#F5D000' : 'rgba(255,255,255,0.55)';
  const lineColor = active ? 'rgba(245,208,0,0.5)' : 'rgba(255,255,255,0.3)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="1 1 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19 13.5C19 14.3284 18.3284 15 17.5 15H6.5L3 19V4.5C3 3.67157 3.67157 3 4.5 3H17.5C18.3284 3 19 3.67157 19 4.5V13.5Z"
        stroke={strokeColor}
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <line
        x1="7"
        y1="7.5"
        x2="15"
        y2="7.5"
        stroke={lineColor}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <line
        x1="7"
        y1="11"
        x2="12"
        y2="11"
        stroke={lineColor}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
